   <div class="overlay" *ngIf="isLoading">
      <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
    </div>
  <div class="diagnostics-container">
    <section class="diagnostics-section">
      <div class="section-header">
        <div class="diagnostic-header">
          <div class="tab active">
           {{ "events.header" | transloco }}
          </div>
        </div>
      </div>
      <div class="icons-container">
        <span></span>
        <!-- <div class="icons">
          <i class="pi pi-search"></i>
          <i class="pi pi-filter"></i>
        </div> -->
      </div>
      

        <div class="banner-container">
          <picture style="width: 100%;">
            <source media="(max-width: 480px)" srcset="/assets/img/ftchimarrao/banner-ftpass-mobile.png">
            <img src="/assets/img/ftchimarrao/banner-ftpass.png" alt="">
          </picture>
        </div>
        <div class="titleEvent">
          <h1>{{ "events.title" | transloco }}</h1>
        </div>
        <div class="carousel-container">
          <div class="carousel-wrapper">
            <div class="carousel-inner">
              <div class="carousel-item" *ngFor="let visual of eventVisualList">
                <app-card-events
                  [events]="visual.event"
                  [buttonsOpacity]="visual.buttonsOpacity"
                  [generalOpacity]="visual.generalOpacity"
                  [infoOpacity]="visual.infoOpacity"
                  [hasCheckin]="visual.hasCheckin"
                  [disableButtons]="visual.disableButtons"
                  [showQRCode]="visual.showQRCode"
                  (checkInEvent)="startScanner(visual.event)"
                  (infoEvent)="showInfoDialog(visual.event)"
                  (showQRCodeEvent)="showUserQRCode()"
                ></app-card-events>
              </div>
            </div>
          </div>
          <zxing-scanner
            *ngIf="scannerActive"
            [autostart]="true"
            (scanSuccess)="handleQrCode($event)"
            class="fullscreen-scanner">
          </zxing-scanner>
          
          <button *ngIf="scannerActive" class="close-scanner" (click)="scannerActive = false">
            {{ "events.closeScanner" | transloco }}
          </button>

        </div>
    </section>
  </div>    

      <p-dialog 
        id="infoDialog" 
        [header]="'events.eventInfo' | transloco"
        [modal]="true"
        [draggable]="false"
        [dismissableMask]="true"
        [(visible)]="modalShowInfoDialog"
        (onShow)="initMap()">
        <div class="dialog-body">
          <h2 class="event-title">{{eventName}}</h2>
          <div class="event-description">
            <div [innerHTML]="eventDescription"></div>
          </div>
          <div id="map" style="height: 400px; width: 100%;"></div>
        </div>
        <div class="dialog-footer">
          <p-button severity="danger" [label]="'common.buttons.close' | transloco" class="close-button" (click)="modalShowInfoDialog = false"></p-button>
        </div>
      </p-dialog>


<p-dialog [(visible)]="modalShowCheckin" 
  [modal]="true" 
  [closable]="false" 
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{width: '700px'}"
  [header]="'events.checkIn' | transloco" 
  contentStyleClass="checkin-dialog-content">
  <div class="checkin-container">
    

    <div class="card-options" *ngIf="!isTypedQrcode">
      <div class="overlay" *ngIf="isLoadingModalQr">
        <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
      </div>
      <h3 class="title">{{ "events.checkInQuestion" | transloco }}</h3>
      <div class="options">
      <div class="option" role="button" tabindex="0" (click)="scannerActive = true">
        <div class="icon">
          <i class="pi pi-camera"></i>
        </div>
        <div class="label">
          <strong>{{ "events.scanQRCode" | transloco }}</strong>
          <span>{{ "events.withCamera" | transloco }}</span>
        </div>
      </div>

      <div class="option" role="button" tabindex="0" (click)="isTypedQrcode = true">
        <div class="icon">
          <i class="pi pi-pen-to-square"></i>
        </div>
        <div class="label">
          <strong>{{ "events.typeCode" | transloco }}</strong>
        </div>
      </div>
    </div>

    <div class="footer">
        <div class="button-wrapper" (click)="closeModalCheckin()">
          <div class="button-inner">
            <p-button id="btnBack" name="btnBack" [label]="'common.buttons.close' | transloco" [raised]="true"
              styleClass="custom-button"><i class="pi pi-angle-left" style="margin-right: 5px;"></i></p-button>
          </div>
        </div>
    </div>
  </div>

      <div class="typedQr" *ngIf="isTypedQrcode">
        <h3 class="title">{{ "events.typeCodeInstructions" | transloco }}</h3>
        <input
          type="text"
          id="typedQrcode"
          name="typedQrcode"
          [(ngModel)]="typedQrcode"
          [placeholder]="'events.qrcodeInput' | transloco"
          pInputText
        />
        <div class="footer">
          
          <div class="button-wrapper" (click)="backCheckin()">
            <div class="button-inner">
              <p-button id="btnBack" name="btnBack" [label]="'common.buttons.back' | transloco" [raised]="true"
                styleClass="custom-button"><i class="pi pi-angle-left" style="margin-right: 5px;"></i></p-button>
            </div>
          </div>
          <p-button id="btnConfirmQr" severity="danger" name="btnConfirmQr" [label]="'common.buttons.confirm' | transloco" [loading]="confirmCheckinBtn"
            [raised]="true" (click)="handleQrCode(typedQrcode)"/>
        </div>

    </div>

  </div>
</p-dialog>


<p-dialog [(visible)]="modalShowQRCode" 
  [modal]="true" 
  [closable]="true" 
  [draggable]="false"
  [dismissableMask]="true"
  [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
  [style]="{width: '400px', 'max-width': '90vw'}"
  [header]="'events.yourQRCode' | transloco" 
  contentStyleClass="qrcode-dialog-content">
  <div class="qrcode-container" style="text-align: center; padding: 15px;">
    <p style="margin-bottom: 15px; font-size: 14px;">{{ "events.presentQRCode" | transloco }}</p>
    <div style="display: flex; justify-content: center; align-items: center; padding: 10px;">
      <img [src]="qrCodeImage" [attr.alt]="'events.qrCodeAlt' | transloco" style="max-width: 100%; height: auto; max-height: 300px; width: auto;" />
    </div>
  </div>
  <div class="dialog-footer" style="text-align: center; padding-top: 10px;">
    <p-button severity="danger" [label]="'common.buttons.close' | transloco" (click)="modalShowQRCode = false" styleClass="p-button-sm"></p-button>
  </div>
</p-dialog>


<p-toast key="toastMessages" />
